type RemoveElementFunction = (
  setValue: (name: string, value: any, options?: object) => void,
  watch: (name: string) => any[],
  listName: string,
  id: number | string
) => void;

export const onRemoveElement: RemoveElementFunction = (
  setValue,
  watch,
  listName,
  id
) => {
  setValue(
    listName,
    watch(listName).filter((sid: number) => sid !== id),
    { shouldDirty: true }
  );
};
